import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, UpdateBeMarketSegments } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateBeMarketSegments } from '../businessEntityApi';

function* updateBeMarketSegmentsSaga(action: UpdateBeMarketSegments) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<{ businessEntityId: number; marketSegmentIds: number[] }> = yield call(
    updateBeMarketSegments,
    action.payload
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(
      businessEntityActionCreators.setMarketSegments({
        beId: response.value.businessEntityId,
        marketSegmentIds: response.value.marketSegmentIds
      })
    );
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateBeMarketSegments() {
  yield takeEvery(BusinessEntityActionKeys.UPDATE_BE_MARKET_SEGMENTS, updateBeMarketSegmentsSaga);
}
